export interface AiChatBannerData {
  message: string;
  version: number;
}

export interface AiChatBannerProps {
  banner: AiChatBannerData;
}

export const AI_CHAT_BANNER_DISMISSED_KEY = 'ai_chat_banner_dismissed_version';
